<template>
  <Badge :badgeTypes="badgeTypes" :backgroundColor="backgroundColor" />
</template>

<script>
import { determineIfLastChance, determineIfSoldOut } from '@/helpers/product-availabilty.js'
import { BADGES } from '@/components/_shared/Badge/Badge.vue'
import Badge from '@/components/_shared/Badge/Badge.vue'
import { BACKGROUND_COLORS } from '@/components/_shared/Badge/Badge.vue'

export default {
  name: 'LabelBadge',
  components: { Badge },
  props: {
    productLabels: {
      type: Array,
      required: true,
    },
    productVariantLabels: {
      type: Array,
      required: true,
    },
    skus: {
      type: Array,
      required: true,
    },
    isBackorderable: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: BACKGROUND_COLORS.grey,
    },
  },

  computed: {
    badgeTypes() {
      return [
        ...this.productLabels,
        ...this.productVariantLabels,
        ...this.lastChanceLabel,
        ...this.soldOutLabel,
      ]
    },

    lastChanceLabel() {
      return determineIfLastChance(this.skus, this.isBackorderable) ? [BADGES.lastChance.type] : []
    },

    soldOutLabel() {
      return determineIfSoldOut(this.skus) ? [BADGES.soldOut.type] : []
    },
  },
}
</script>

<style lang="scss">
</style>
